import React, { useState } from 'react'
import clsx from 'clsx'
import { COLORES } from '../../../../config/colores'
import { AppBar, Collapse, CssBaseline, Drawer, IconButton, List, ListItem, ListItemText, Toolbar, Typography } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'
import MenuIcon from '@material-ui/icons/Menu'
import { Link } from 'react-router-dom'
import LoginInfo from '../../../Auth/containers/LoginInfo'
import { CreateAuthz } from '../../../Authz/containers/AuthzHocCreator'
import { COMPONENT_PERMS } from '../../../Authz/types'
import { ITEMS_MOVIMIENTO, ITEMS_PREINGRESO } from '../config/ItemsMenuDrawer'
import HeaderApp from '../../components/HeaderApp'
import MenuInstitucional from './MenuInstitucional'

const drawerWidth = 300

// const registrarAccesoAMenu = async ({ url, name }) => getAxiosInstance().post(
//   '/user_frequent_access', { valores: { user_name: (await User.getStatus()).user, route_id: url, route_name: name } })

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex'
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginLeft: -drawerWidth
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: 0
  },
  nested: {
    paddingLeft: theme.spacing(2),
    bgcolor: 'background.paper'
  },
  PagName: {
    flexGrow: 1,
    cssFloat: 'left'
  },
  fuenteNegra: {
    color: 'black'
  }

}))

export default function PersistentDrawerLeft () {
  const classes = useStyles()
  const theme = useTheme()
  const stateMenuAbierto = useState(false)
  const openMenu = stateMenuAbierto[0]
  const setOpenMenu = stateMenuAbierto[1]
  const [openSubmenus, setOpenSubmenus] = useState({})

  const ListItemExpandible = (item) => (
    <>
      <ListItem
        button
        onClick={() => setOpenSubmenus((state) => ({ ...state, [item.name]: !state[item.name] }))}
        key={item.name}
      >
        <>{item.icono}&nbsp;<ListItemText primary={item.name} /></>
        {openSubmenus[item.name] ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={openSubmenus[item.name]} timeout={2000} unmountOnExit>
        <List className={classes.nested}>
          {generateListItems(item.subgrupos)}
        </List>
      </Collapse>
    </>
  )

  const generateListItems = (items) => (
    items.map((item, index) => {
      const ItemClass = CreateAuthz(COMPONENT_PERMS[item.url], false)(() => (
        <>
          {item.subgrupos && item.subgrupos.length ? ListItemExpandible(item)
            : <Link onClick={() => {
              setOpenMenu(false)
              // registrarAccesoAMenu(item)
            }} to={item.url}>
              <ListItem>
                <ListItemText className={classes.fuenteNegra} primary={item.name} />
              </ListItem>
            </Link>}
        </>
      ))
      return <ItemClass key={index} />
    })
  )

  return (
    <div className={classes.root}>
      <CssBaseline />
      <>
        <div>

          <AppBar
            // position='fixed'
            style={{ backgroundColor: 'transparent' }}
            className={clsx(classes.appBar, {
              [classes.appBarShift]: openMenu
            })}
          >
            <Toolbar className='App-laridae-header-toolbar'>
              {/* TODO: CAMBIAR COLLAPSE HORIZONTAL CUANDO ESTE DISPONIBLE EN MATERIAL UI (https://github.com/mui-org/material-ui/blob/next/CHANGELOG.md#material-uicorev500-alpha2) */}
              <IconButton
                color='inherit'
                aria-label='open drawer'
                onClick={() => setOpenMenu(!openMenu)}
                style={{ outline: 'none', margin: '16px', padding: '0' }}
                edge='start'

                className={clsx(classes.menuButton /* openMenu && classes.hide */)}
              >
                <MenuIcon style={{ color: COLORES.grey.light }} />
              </IconButton>
              <HeaderApp />
            </Toolbar>

            <MenuInstitucional />

          </AppBar>
        </div>

      </>
      <Drawer
        className={classes.drawer}
        variant='persistent'
        anchor='left'
        open={openMenu}
        classes={{
          paper: classes.drawerPaper
        }}
      >
        <div className={classes.drawerHeader}>
          <Typography variant='h5' className='pag-name {classes.PagName}'>Menú Principal</Typography>
          <IconButton onClick={() => setOpenMenu(false)}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </div>
        <List>
          {generateListItems(ITEMS_MOVIMIENTO)}
        </List>
        {true && <List>
          {generateListItems(ITEMS_PREINGRESO)}
        </List> }
        <LoginInfo style={{ margin: '0 8% 0 0' }} />
      </Drawer>
      <div style={{ backgroundColor: '#ffffff', height: '28px' }} />

    </div>
  )
}
